import OrganisationSwitcher from "OrganisationSwitcher";
import { Tabs } from "minimum-ui/core";
import styled from "styled-components";
import { Avatar } from "ui/core";

import urls from "utilities/urls";

import { Logo, NavContainer, NavLine } from "Common/styles";

import { useNavigation } from "./useNavigation";

const Navigation = () => {
  const {
    currentOrg,
    email,
    isHubFeatureFlagEnabled,
    links,
    name,
    userOrganisations,
    navigate,
    onChange,
  } = useNavigation();

  return (
    <NavContainer>
      <Logo
        src={currentOrg?.minimumLogoUrl}
        onClick={() => {
          navigate(urls.home());
        }}
      />

      <AlignFlexEnd>
        <Tabs tabs={links} onChange={onChange} variant="scrollable" />
      </AlignFlexEnd>

      <RightHandSelectors>
        <StyledAvatar
          label={name || email}
          size={32}
          onClick={() => {
            navigate(urls.settings());
          }}
        />
        {(userOrganisations?.length !== 1 || isHubFeatureFlagEnabled) &&
          currentOrg && (
            <>
              <NavLine />
              <OrganisationSwitcher currentOrg={currentOrg} />
            </>
          )}
      </RightHandSelectors>
    </NavContainer>
  );
};

const StyledAvatar = styled(Avatar)`
  margin-left: auto;
  cursor: pointer;
`;

const RightHandSelectors = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: auto;
`;

const AlignFlexEnd = styled.div`
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-end;
`;

export default Navigation;
